import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { BaseUrl } from "../../../../assets/GlobalVariables";
import { Button, Input, message } from "antd";
import { useOrder } from "../../../../contexts/OrderContext";

const Offer = ({}) => {
  const { saveInfoFunc, savingInfo } = useOrder();
  const { dynamicOrderId, hotelOrderId } = useParams();

  const dynamicOrderLink = useMemo(() => {
    if (dynamicOrderId) return BaseUrl + "/dynamic/offer/" + dynamicOrderId;
    if (hotelOrderId) return BaseUrl + "/hotel/offer/" + hotelOrderId;
    return null;
  }, [dynamicOrderId, hotelOrderId]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        width: "calc(100% - 20px)",
        padding: "10px",
        backgroundColor: "#ffffff",
        borderBottom: "5px solid #e8e8e8",
        borderTop: "5px solid #e8e8e8",
      }}
    >
      <Button
        type="primary"
        disabled={savingInfo}
        onClick={() => {
          saveInfoFunc(true);
        }}
      >
        {dynamicOrderLink ? "עדכן" : "צור"} הצעת מחיר ללקוח
      </Button>
      {dynamicOrderLink ? (
        <>
          <Input
            disabled
            value={dynamicOrderLink}
            styles={{
              input: {
                width: "100%",
                textAlign: "center",
              },
            }}
          />
          <Button
            type="dashed"
            onClick={() => {
              navigator.clipboard.writeText(dynamicOrderLink);
              message.success("הקישור הועתק בהצלחה");
            }}
            disabled={savingInfo}
          >
            העתק קישור הצעת מחיר
          </Button>
        </>
      ) : null}
    </div>
  );
};

export default Offer;
